import { useState } from "react";
import { api, formatBRL } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function ShippingQuote({ items, cep, onSelect, selected }) {
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(null);
  const [configured, setConfigured] = useState(true);

  const quote = async () => {
    if (!cep || cep.replace(/\D/g, "").length !== 8) return;
    setLoading(true);
    try {
      const payload = {
        dest_cep: cep,
        items: items.map((i) => ({ product_id: i.product_id, quantity: i.quantity, size: i.size, variation: i.variation })),
      };
      const { data } = await api.post("/shipping/quote", payload);
      setOptions(data.options || []);
      setConfigured(data.configured);
    } catch { setOptions([]); }
    setLoading(false);
  };

  return (
    <div className="bg-white border border-[#C2A064]/20 p-5" data-testid="shipping-widget">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h4 className="text-[11px] tracking-[0.3em] uppercase text-[#49392F]">Frete</h4>
        <button type="button" onClick={quote} className="duo-btn duo-btn-secondary !py-2 !px-4 !text-[10px]" disabled={loading} data-testid="quote-shipping-button">
          {loading ? <Loader2 size={12} className="animate-spin" /> : "Calcular"}
        </button>
      </div>
      {options === null && <p className="text-[12px] text-[#49392F]/60">Preencha o CEP e clique em "Calcular" para ver as opções.</p>}
      {options !== null && options.length === 0 && !configured && (
        <p className="text-[12px] text-[#49392F]/70">O cálculo automático ainda não está habilitado. O valor do frete será confirmado por WhatsApp após o pedido.</p>
      )}
      {options !== null && options.length === 0 && configured && (
        <p className="text-[12px] text-[#49392F]/70">Não encontramos opções para este CEP. Confirmaremos o frete por WhatsApp.</p>
      )}
      {options && options.length > 0 && (
        <div className="space-y-2">
          {options.map((o) => {
            const id = `${o.company}-${o.name}-${o.price}`;
            const isSel = selected?.id === o.id;
            return (
              <label key={id} className={`flex items-center justify-between gap-2 p-3 border cursor-pointer ${isSel ? "border-[#49392F] bg-[#E8DCCB]/40" : "border-[#C2A064]/20"}`}>
                <div className="flex items-center gap-3">
                  <input type="radio" checked={isSel} onChange={() => onSelect(o)} />
                  <div>
                    <div className="text-[13px] text-[#49392F]">{o.company} — {o.name}</div>
                    <div className="text-[11px] text-[#49392F]/60">Prazo: {o.delivery_time} dias úteis</div>
                  </div>
                </div>
                <div className="text-[14px] text-[#49392F] font-medium">{formatBRL(o.price)}</div>
              </label>
            );
          })}
        </div>
      )}
    </div>
  );
}
